export default __webpack_public_path__ + "static/media/93t.dae1616b.jpg";